class BESSAppProjectIWMWaterSpaceProfilerManager extends BESSAppProjectProfilerManager {

    start() {
        super.start();
        this.#updateState();
    }


    updated() {
        super.updated();
        this.#updateState();
    }

    #updateState() {
        let connectedToWhichTankField = this.profiler.data.getFieldForAttribute('connectedToWhichTank');
        let hasValidChoices = connectedToWhichTankField.choices.length > 1;
        this.profiler.views.root.find('.app-editor-field-connectedToWhichTank').showIf(hasValidChoices);

    }
}